
import { MutationsService } from '@vedicium/object-mutations';
import Vue, { PropType } from 'vue';
import { APP_ERROR_EVENT } from '../../../../../constants';
import { Core } from '../../../../../services/core';

import { OptionPartEntity, OptionPartsStore } from '../../../../../services/parts';
import { PartsOptionsSublinesForm } from '../components';

export default Vue.extend({
  name: 'partsOptionsViewManufacturing',
  components: {
    PartsOptionsSublinesForm,
  },
  props: {
    option: {
      type: Object as PropType<OptionPartEntity>,
    },
  },
  data() {
    return {
      isLoadingForm: false,

      metadata: {
        option: JSON.parse(JSON.stringify(this.option)) as OptionPartEntity,
      },
    };
  },

  methods: {
    onAddSublineClick(): void {
      (this.$refs.sublinesForm as any).onAddSubline();
    },
    async onSublinesUpdate(): Promise<void> {
      try {
        await this.onSubmit();
      } catch (e) {
        this.$set(this.metadata, 'option', JSON.parse(JSON.stringify(this.option)));
      }
    },

    async onSubmit() {
      this.$set(this, 'isLoadingForm', true);
      try {
        const mutations = MutationsService.getMutationsByComparison(
          this.option,
          this.metadata.option,
          ['manufacturing.sublines'],
        );

        if (mutations.length > 0) {
          const entity = await OptionPartsStore.update(this.option._meta.guid, mutations);

          this.$emit('update:option', entity);
          this.$set(this.metadata, 'option', JSON.parse(JSON.stringify(entity)));
        }

        this.$bvToast.toast('Document successfully updated', {
          title: 'Update successful',
          variant: 'success',
          solid: true,
        });
      } catch (e) {
        Core.Eventhub.emit(APP_ERROR_EVENT, e);
        console.error(e);
        throw e;
      } finally {
        this.$set(this, 'isLoadingForm', false);
      }
    },
  },
});
